'use client';
import { useCustomer } from '@hooks/customer';
import BazaarvoiceReviews from '@repo/ui/src/components/BazaarvoiceReviews';

type ProductType = 'product' | 'recipe' | 'apparel';

interface Props {
  sku: string;
  type: ProductType;
}

const Reviews = ({ sku, type }: Props) => {
  const { data: user } = useCustomer();
  return <BazaarvoiceReviews sku={sku} type={type} userEmail={user?.email} />;
};

export default Reviews;
